import { render, staticRenderFns } from "./PalletQuickViewDialog.vue?vue&type=template&id=7841a8fa&scoped=true&"
import script from "./PalletQuickViewDialog.vue?vue&type=script&lang=js&"
export * from "./PalletQuickViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./PalletQuickViewDialog.vue?vue&type=style&index=0&id=7841a8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841a8fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VLayout,VSpacer})
